import * as z from 'zod';
import { FileType, cloudStorageBucketNameSchema, fileExtensionSchema } from '../../enums.mjs';
import { fileId, emailSubmissionId } from '../../types/opaque.mjs';

const maxTextLength = 100_000;
const confirmableFileTypeSchema = z.enum([
    FileType.bond_request_form,
    FileType.contract,
    FileType.bid_package,
]);
const contractV2CandidateFileTypeSchema = confirmableFileTypeSchema.exclude([
    FileType.bond_request_form,
]);
const isContractV2CandidateFileType = (value) => contractV2CandidateFileTypeSchema.safeParse(value).success;
const fileRequestSchema = z.object({
    source: z.literal("file"),
    fileId: fileId,
    fileName: z.string(),
    fileExtension: fileExtensionSchema,
    bucket: cloudStorageBucketNameSchema,
    bucketDirPath: z.array(z.string()).optional(),
    emailSubmissionId: emailSubmissionId.optional(),
    candidateFileType: confirmableFileTypeSchema.optional(),
});
const submissionNarrativeRequestSchema = z.object({
    source: z.literal("submission_narrative"),
    submissionId: z.string().min(1),
    text: z.string().min(1).max(maxTextLength),
});
const emailThreadRequestSchema = z.object({
    source: z.literal("email_thread"),
    gmailThreadId: z.string().min(1),
    text: z.string().min(1).max(maxTextLength),
});
var Extract;
(function (Extract) {
    Extract.MAX_TEXT_LENGTH = maxTextLength;
    (function (Request) {
        Request.schema = z.discriminatedUnion("source", [
            fileRequestSchema,
            submissionNarrativeRequestSchema,
            emailThreadRequestSchema,
        ]);
    })(Extract.Request || (Extract.Request = {}));
})(Extract || (Extract = {}));

export { Extract, confirmableFileTypeSchema, contractV2CandidateFileTypeSchema, isContractV2CandidateFileType };
